import {
    useCreateOrganizationCodeMutation,
    useGetArchivedPaginatedOrganizationCodesMutation,
    useGetPaginatedOrganizationCodesMutation,
    useUpdateOrganizationCodeMutation,
    useToggleArchiveOrganizationCodeMutation
} from '@services/member/list/organization-codes/organization-codes.endpoints';
import { OrganizationCode } from '@services/member/list/organization-codes/organization-codes.types';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useOrganizationCodesPageVM = () => {
    const [totalOrganizationCodes, setTotalOrganizationCodes] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateOrganizationCode,
        {
            isSuccess: isUpdateOrganizationCodeSuccess
        }
    ] = useUpdateOrganizationCodeMutation();

    const [
        createOrganizationCode,
        {
            isSuccess: isCreateOrganizationCodeSuccess
        }
    ] = useCreateOrganizationCodeMutation();

    const [
        toggleArchiveOrganizationCode,
        {
            isSuccess: isToggleArchiveOrganizationCodeSuccess
        }
    ] = useToggleArchiveOrganizationCodeMutation();


    const handleArchiveOrganizationCodes = async (lines: OrganizationCode[], archive: boolean) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce code organisme ?' : 'Êtes-vous sûr de vouloir désarchiver ce code organisme ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces codes organismes ?' : 'Êtes-vous sûr de vouloir désarchiver ces codes organismes ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveOrganizationCode({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreateOrganizationCodeSuccess || isUpdateOrganizationCodeSuccess || isToggleArchiveOrganizationCodeSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [
        isCreateOrganizationCodeSuccess,
        isUpdateOrganizationCodeSuccess,
        isToggleArchiveOrganizationCodeSuccess
    ]);

    useEffect(() => {
        setTotalOrganizationCodes(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalOrganizationCodes(metadata.total);
        }
    };

    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedOrganizationCodesMutation : useGetPaginatedOrganizationCodesMutation;
    }, [isArchived]);

    return {
        mutationHook,
        totalOrganizationCodes,
        setTotalOrganizationCodes,
        isArchived,
        handleMetadata,
        handleArchiveOrganizationCodes,
        needReload,
        setIsArchived,
        MySwal,
        updateOrganizationCode,
        createOrganizationCode
    };
};
